// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qh-9";
export var arrowButtonContainer = "_qh-5";
export var arrowButtonIcon = "_qh-6";
export var carouselArrowButton = "_qh-2";
export var carouselElementContainer = "_qh-1";
export var currentSlide = "_qh-8";
export var left = "_qh-3";
export var otherSlide = "_qh-a";
export var productCarouselContainer = "_qh-0";
export var right = "_qh-4";
export var sliderOverflow = "_qh-7";